export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M15 2a2 2 0 0 1 2 2v2h-2V4H4v16h11v-2h2v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm2 12h-7v-4h7V7l5 5-5 5z\"/>"
};